var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49994 10C4.49994 9.44772 4.94765 9 5.49994 9H15.4999C16.0522 9 16.4999 9.44772 16.4999 10C16.4999 10.5523 16.0522 11 15.4999 11H5.49994C4.94765 11 4.49994 10.5523 4.49994 10ZM4.49994 6C4.49994 5.44772 4.94765 5 5.49994 5H19.4999C20.0522 5 20.4999 5.44772 20.4999 6C20.4999 6.55228 20.0522 7 19.4999 7H5.49994C4.94765 7 4.49994 6.55228 4.49994 6ZM4.49994 14C4.49994 13.4477 4.94765 13 5.49994 13H19.4999C20.0522 13 20.4999 13.4477 20.4999 14C20.4999 14.5523 20.0522 15 19.4999 15H5.49994C4.94765 15 4.49994 14.5523 4.49994 14ZM4.49994 18C4.49994 17.4477 4.94765 17 5.49994 17H12.4999C13.0522 17 13.4999 17.4477 13.4999 18C13.4999 18.5523 13.0522 19 12.4999 19H5.49994C4.94765 19 4.49994 18.5523 4.49994 18Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.5bff29e4808716aaa647f9f8c52fba07.svg";
export { ForwardRef as ReactComponent };